import React from "react";
import { NavLink } from "react-router-dom";

const Header = () => {
  const navItems = [
    { label: "Homepage", path: "/" },
    { label: "Services", path: "/services" },
    { label: "Training", path: "/trainings" },
    { label: "Milestones", path: "/milestones" },
  ];

  return (
    <>
      {/* Top Bar with Background Image */}
      <div
        className="h-[180px] md:h-[200px] flex items-center justify-between border-b border-[#ff8c42] relative bg-cover bg-center bg-no-repeat px-6 md:px-12"
        style={{ backgroundImage: `url(/images/bg.jpg)` }}
      >
        {/* Dark overlay with gradient for better contrast */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/70"></div>

        {/* Left Text */}
        <div className="text-left text-white select-none font-[Montserrat] relative z-10 max-w-lg">
          <div className="text-4xl md:text-5xl font-bold leading-tight drop-shadow-lg">
            S&amp;J
          </div>
          <div className="text-lg md:text-xl font-medium mt-1 drop-shadow-md">
            Solutions and Services
          </div>
          <div className="text-sm md:text-base mt-1 text-white/90 drop-shadow-md">
            Outdoor Services & Accredited Training Programs
          </div>
        </div>

        {/* Right Logo */}
        <div className="relative z-10">
          <img
            src="/images/sandj-logo.png"
            alt="S&J Logo"
            className="h-[110px] w-auto object-contain"
          />
        </div>
      </div>

      {/* Navigation Bar */}
      <div className="bg-[#4b774f]">
        <nav className="flex flex-wrap justify-center gap-4 py-3 px-4">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                [
                  "uppercase font-bold font-[Montserrat] px-4 py-2 rounded-md text-white transition-all duration-300",
                  "bg-[#6b8e23] hover:bg-[#85a94f] hover:scale-105 shadow-md",
                  isActive
                    ? "bg-[#d6e9c6] text-[#2f4f2f] shadow-inner border border-[#ff8c42]"
                    : "",
                ].join(" ")
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </>
  );
};

export default Header;
